import type { Dashboard } from '../../types/Dashboard';

export const dashboardBaseFeatureConfig: Dashboard = {
    hidePerformanceForFlags: [],
    hideSettingsForFlags: [],
};
